/**
import { replaceInChain } from '@insite/client-framework/HandlerCreator';
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadBrandAlphabet } from '@insite/client-framework/Store/Pages/Brands/Handlers/LoadBrandsAlphabet';

export const XngDispatchCompleteLoadBrandAlphabet: typeof DispatchCompleteLoadBrandAlphabet = props => {
    props.dispatch({
        type: "Pages/Brands/CompleteLoadBrandAlphabet",
        result: {
            alphabet: props.result.brandAlphabetLetters || [],
            properties: props.result.apiResult?.properties
        } as any,
    });
};

replaceInChain(chain, DispatchCompleteLoadBrandAlphabet, XngDispatchCompleteLoadBrandAlphabet);